export default __webpack_public_path__ + "static/media/gitkraken.f76e4685.svg";